module.exports = __webpack_public_path__ + "static/open_fct1-980d1fe13f4d10a9bef4b758cdfc8253.jpg";